import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

import safeLocalStorage from 'client/lib/safeLocalStorage';
import parseJSON from 'common/util/parseJSON';

import { SR_API_ACTION_PLAID_CREATE_STRIPE_BANK_ACCOUNT } from 'api/actionTypes';

import { SCREEN_ID_PLAID_OAUTH } from 'client/constants/screenIds';

import branch from 'client/core/branch';
import postWithState from 'client/actions/postWithState';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';

import OpenPlaidLink from 'client/components/OpenPlaidLink';

@withTransitionHook
@withScreenId(SCREEN_ID_PLAID_OAUTH)
@withScrollToTop
@branch()
class PlaidOauthPage extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    isTransitioning: PropTypes.bool.isRequired,
  };

  _getPlaidLinkJSON = () => {
    const plaidLinkJSONFromLocalStorage = safeLocalStorage.getItem('plaidLinkJSON');

    return plaidLinkJSONFromLocalStorage ? parseJSON(plaidLinkJSONFromLocalStorage) : null;
  };

  _onRedirectToSecurityDepositPage = (paymentAccount) => {
    const plaidLinkJSON = this._getPlaidLinkJSON();
    const redirectUrl = `/security-deposit/${plaidLinkJSON.householdId}/${plaidLinkJSON.listingId}`;
    global.location.href = `${redirectUrl}${paymentAccount ? `?pa=${paymentAccount.id}` : ''}`;
  };

  _onPlaidLinkSuccess = (publicToken, metadata) => {
    const { dispatch } = this.props;

    dispatch(postWithState, {
      action: SR_API_ACTION_PLAID_CREATE_STRIPE_BANK_ACCOUNT,
      payload: {
        publicToken,
        metadata,
      },
      onSuccess: (paymentAccount) => {
        this._onRedirectToSecurityDepositPage(paymentAccount);
      },
      onError: () => {
        this._onRedirectToSecurityDepositPage();
      },
    });
  };

  render() {
    const { isTransitioning } = this.props;

    if (process.browser && !isTransitioning) {
      const plaidLinkJSON = this._getPlaidLinkJSON();
      if (!plaidLinkJSON) {
        return <Redirect to="/profile" />;
      }

      return (
        <OpenPlaidLink
          linkToken={plaidLinkJSON.token}
          receivedRedirectUri={global.location.href}
          onSuccess={this._onPlaidLinkSuccess}
          onExit={this._onPlaidLinkExit}
        />
      );
    }

    return null;
  }
}

PlaidOauthPage.displayName = 'PlaidOauthPage';

export default PlaidOauthPage;
